<template>
  <div class="Datasets">
    <b-container fluid>
      <b-card-group deck>
        <b-card title="Search Datasets and Files" border-variant="info" style="background-color: black; color: white">
          <b-form @submit="fetchDatasets" @reset="resetSearchDatasets">
            <label class="mr-sm-2" for="dataset-select-dropdown" style="color: orange">Select dataset scope: </label>
            <b-form-select
              id="dataset-select-dropdown"
              v-model="searchDatasetScope"
              :value="searchDatasetScope"
              :options="items"
            ></b-form-select>
            <label for="dataset-tags" style="color: orange">Enter dataset names separated by space, comma or semicolon</label>
            <b-form-tags
              input-id="dataset-tags"
              v-model="searchDatasetNames"
              separator=" ,;"
              placeholder="Enter dataaset names separated by space, comma or semicolon: "
              no-add-on-enter
            ></b-form-tags>
            <b-button type="submit" variant="success">
              <b-icon icon="search" aria-hidden="true" font-scale="1.0"></b-icon> Search
            </b-button>
            <b-button type="reset" variant="danger"><b-icon icon="arrow-repeat" aria-hidden="true" font-scale="1.0"></b-icon> Reset</b-button>
          </b-form>
        </b-card>
      </b-card-group>
      <h6 v-if="this.showDatasets === true"> Showing Datasets</h6>
      <p v-if="this.showNumDatasets === true"> Num Datasets found for this scope {{this.searchFilesScope}}: {{numDatasets}} </p>
      <b-table
               v-if="this.showDatasets === true"
               title="Datasets"
               dark
               sticky-header="400px"
               responsive
               :items="datasets"
               :fields="datasetFields"
               :small="smallTable"
               :filter="filter"
               :sort-by.sync="sortBy"
               :sort-desc.sync="sortDesc"
               :sort-direction="sortDirection"
               @filtered="onFiltered"
            >
        <template #cell(actions)="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? 'Hide' : 'Show' }} Policies
          </b-button>
        </template>
        <template #row-details="row">
          <b-card-group deck>
            <b-card
              bg-variant="dark">
              <h6>Replication Policy</h6>
              Preferred Storage Locations: {{row.item.replication_policy.preferred_storage_elements}}
            </b-card>
            <b-card bg-variant="dark">
              <h6>Deletion Policy</h6>
              <b-table
                dark
                :items="row.item.deletion_policy"
                :fields="deletionPolicyFields"
                :small="smallTable"
              >
              </b-table>
            </b-card>
          </b-card-group>
        </template>
      </b-table>
      <h6 v-if="this.showFiles === true"> File information: </h6>
      <h4 v-else style="color: orange"> File information is only shown if you select a single dataset name.</h4>
      <b-table
         v-if="this.showFiles === true"
         dark
         sticky-header="400px"
         responsive
         :items="files"
         :fields="fileFields"
         :small="smallTable"
         :filter="filter"
         :sort-by.sync="sortBy"
         :sort-desc.sync="sortDesc"
         :sort-direction="sortDirection"
         @filtered="onFiltered"
      >
        <template #cell(actions)="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? 'Hide' : 'Show' }} Replica Details
          </b-button>
        </template>
        <template #row-details="row">
          <b-card bg-variant="dark">
            <b-table
              dark
              :items="row.item.replica_info"
              :fields="replicaInfoFields"
              :small="smallTable"
            >
            <template #cell(quality)="r">
              <b-icon v-if="r.quality === good" icon="check-square-fill" aria-hidden="true" font-scale="1.0" variant="success" >
              </b-icon>
              <b-icon v-else icon="question-square-fill" variant="warning" font-scale="1"></b-icon>
            </template>
            </b-table>
          </b-card>
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
// import { AuthVerificationMixin } from '../mixins/auth_mixin.js'
export default {
  // mixins: [AuthVerificationMixin],
  data () {
    return {
      eventNum: null,
      items: [],
      datasets: [],
      files: [],
      numDatasets: null,
      showFiles: false,
      showDatasets: false,
      showNumDatasets: false,
      deletionPolicyFields: ['storage_element', 'delete_after_days'],
      datasetFields: ['name', 'scope', 'num_files', 'belongs_to', 'actions'],
      fileFields: ['name', 'size_gb', 'num_replicas', 'actions'],
      replicaInfoFields: ['storage_element', {key: 'deletion_state', label: 'State'}, 'quality', 'delete_after', 'replicate_to'],
      plots: {},
      searchDatasetNames: [],
      searchDatasetScope: null,
      smallTable: true,
      dark: false,
      fixed: true,
      currentPage: 1,
      perPage: 5,
      // totalRows: items.length,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      sortBy: 'id',
      plot: null,
      sortDesc: true,
      sortDirection: 'asc',
      filter: null
    }
  },
  mounted () {
    // this.refreshToken()
    this.fetchStorageElements()
    // setInterval(this.fetchStorageElements, 5000)
  },
  computed: {
    totalRows () {
      return this.items.length
    }
  },
  methods: {
    fetchStorageElements () {
      var url = 'https://frb.chimenet.ca/maestro/datatrail/datasets/scopes'
      // this.refreshToken()
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.get(url, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.parseDatasetScopes(response.body)
        })
    },
    parseDatasetScopes (datasetScopes) {
      this.items = datasetScopes
    },
    fetchDatasets (event) {
      event.preventDefault()
      let url = 'https://frb.chimenet.ca/maestro/datatrail/datasets/datasets-files'
      // this.refreshToken()
      if (this.searchDatasetScope === null) {
        return
      }
      const payload = {'dataset_scope': this.searchDatasetScope, 'dataset_names': this.searchDatasetNames}
      var authHeaders = {'Authorization': localStorage.accessToken}
      this.$http.post(url, payload, {headers: authHeaders}, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.showDatasets = false
          this.showFiles = false
          this.showNumDatasets = false
          this.files = []
          this.datasets = []
          this.numDatasets = null
          this.parseDatasets(response.body)
        })
    },
    resetSearchDatasets (event) {
      event.preventDefault()
      this.searchDatasetNames = []
      this.searchDatasetScope = null
    },
    parseDatasets (payload) {
      if (Object.keys(payload).includes('datasets')) {
        this.datasets = payload.datasets
        this.showDatasets = true
      }
      if (Object.keys(payload).includes('files')) {
        this.files = payload.files
        this.showFiles = true
      }
      if (Object.keys(payload).includes('num_datasets')) {
        this.numDatasets = payload.num_datasets
        this.showNumDatasets = true
      }
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Datatrail/datasets.vue